/**
 * We need our ids to be short enough and also be distributed over time.
 * We also need out ids to be neat, with just lowercase and numbers. Easy to select and to look good in the URLs.
 *
 * All ids should have a space and time component
 */

// number of milliseconds elapsed since the epoch as of 1st Nov 2023
// having a set beginning creates much smaller IDs in the time component
// as this ingores all the time that has elapsed from January 1, 1970 to the beginning which is 1st Nov 2023 in this case.
const beginning = 1698803666528;

// moves randomly in space - 100,000 possible values (within the space of a second)
const space = () => Math.floor(Math.random() * 100000).toString(36);
const time = () => Math.floor((Date.now() - beginning) / 1000).toString(36); // moves forward every second

// space should always come first, otherwise we will endup in sequential ids
// the reason space and time has to be seperated by an `_` is because, the lenght of the space component will change
// this could result in duplicate IDs being created because of the suffix of the space component acting as a prefix of the previously occured time component
export const createId = () => `${space()}_${time()}`.toUpperCase();

// for firetore IDs the values should not be sequential,
// but for uploads to GCS, it has to be sequential, so that we can sort the files by name and it will be based on the uploaded time.
// so here we are using time component first followed by space
export const createFileId = () => `${time()}_${space()}`.toUpperCase();

export const createRandomPassword = () => `${space().toUpperCase()}_${time()}_${space()}`;

export const idFactory = {
  createId,
  createFileId,
  createRandomPassword,
};
